import { commonConstants } from "../actions/constants/commonConstants";

const initialState: any = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: undefined,
    error: undefined,
};

export const commonReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case commonConstants.showMessageSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                message: action.payload
            }
        case commonConstants.showMessageFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case commonConstants.clearMessage:
            return { ...initialState };
        default:
            return state;
    }
}

export const getServiceReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.getServiceRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.getServiceSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                servicedata: action.payload
            }
        case commonConstants.getServiceFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getServiceParamsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.getServiceParamsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.getServiceParamsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                servicedata: action.payload
            }
        case commonConstants.getServiceParamsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}


export const getServiceViewReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.serviceViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.serviceViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                serviceview: action.payload
            }
        case commonConstants.serviceViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const createServiceReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.createServiceRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.createServiceSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                servicedata: action.payload
            }
        case commonConstants.createServiceFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const serviceToggleReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.serviceToggleRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.serviceToggleSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                toggledata: action.payload
            }
        case commonConstants.serviceToggleFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const deleteServiceReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.deleteServiceRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.deleteServiceSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                deletedService: action.payload
            }
        case commonConstants.deleteServiceFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const deleteFilesReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.fileDeleteRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.fileDeleteSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                deleted: action.payload
            }
        case commonConstants.fileDeleteFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}



export const sendemailReducer = (state = {}, action: any) => {
    switch (action.type) {
        case commonConstants.contactEmailRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case commonConstants.contactEmailSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                deletedService: action.payload
            }
        case commonConstants.contactEmailFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}